export {};
//# sourceMappingURL=LoggerOptions.js.map